export type AuthGateState = 'app' | 'pending' | 'recovery' | 'redirect';

interface AuthGateInput {
  isLive: boolean;
  isLoading: boolean;
  hasError: boolean;
  configured: boolean;
  hasUser: boolean;
  authError: string | null;
}

export function resolveAuthGate({
  isLive,
  isLoading,
  hasError,
  configured,
  hasUser,
  authError,
}: AuthGateInput): AuthGateState {
  if (!isLive) return 'app';
  if (isLoading) return 'pending';
  if (hasError) return 'recovery';
  if (configured && !hasUser) return authError ? 'recovery' : 'redirect';
  return 'app';
}

export function cleanAuthReturnTo(pathname: string, search: string, hash: string): string {
  const searchParams = new URLSearchParams(search);
  searchParams.delete('authError');
  const cleanSearch = searchParams.size > 0 ? `?${searchParams.toString()}` : '';
  return `${pathname}${cleanSearch}${hash}`;
}

export function authErrorMessage(value: string | null): string {
  if (value === 'cancelled') return 'Google sign-in was cancelled. Try again when you are ready.';
  if (value === 'account') return 'Use an approved Tidal Google account to continue.';
  if (value === 'provider') return 'Google sign-in is temporarily unavailable. Please try again.';
  return 'The sign-in request expired or was opened in another browser. Please try again.';
}
